// Canal d'acquisition proposé à l'inscription (User.signupSource) — liste
// partagée entre le formulaire d'inscription (components/sign-up-form.tsx)
// et l'affichage admin (dashboard/statistiques). Simple tableau de valeurs
// (pas un enum Prisma), cf. schema.prisma pour la justification.
export const SIGNUP_SOURCES = [
  { value: "ami", label: "Un ami ou une amie" },
  { value: "professeur", label: "Un·e professeur·e" },
  { value: "reseaux_sociaux", label: "Réseaux sociaux" },
  { value: "recherche", label: "Recherche internet" },
  { value: "etablissement", label: "Mon établissement scolaire" },
  { value: "autre", label: "Autre" },
] as const;

export type SignupSourceValue = (typeof SIGNUP_SOURCES)[number]["value"];

export function signupSourceLabel(value: string | null): string {
  if (!value) return "Non renseigné";
  return SIGNUP_SOURCES.find((s) => s.value === value)?.label ?? value;
}
